import { KICK_TYPE } from '../constants/constants';

const convertToFirestoreStorageFormat = (startTime, endTime, strength, kickList) => {
  const output = {
    start: new Date(startTime),
    end: new Date(endTime),
    total: kickList.length,
    flutter: [],
    general: [],
    kick: [],
    roll: [],
    swish: [],
    strength,
    title: 'Movement Counting Session',
  };

  kickList.forEach(({ kickType, createdAt }) => {
    const dateObject = new Date(createdAt);
    switch (kickType) {
      case KICK_TYPE.GENERAL:
        output.general.push(dateObject);
        break;
      case KICK_TYPE.FLUTTER:
        output.flutter.push(dateObject);
        break;
      case KICK_TYPE.KICK:
        output.kick.push(dateObject);
        break;
      case KICK_TYPE.ROLL:
        output.roll.push(dateObject);
        break;
      case KICK_TYPE.SWISH:
        output.swish.push(dateObject);
        break;
      default:
        break;
    }
  });

  return output;
};

export default convertToFirestoreStorageFormat;
